// extracted by mini-css-extract-plugin
module.exports = {"main":"UnregistrationReminder_main__ZVcJ6"};